import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Patient, Practitioner, Provenance } from 'fhir/r4'
import { makeName } from '../../../lms/utils'
import { getProvenanceData } from '../../../patients/utils'
import { startSxpProxy } from '../../../../utils/api'
import { REGISTRATION_PROJECT_ID } from '../../../../utils/constants'
import ProvenanceView from '../../../../components/ProvenanceView'
import { ProvenanceData } from '../../../patients/patientsSlice'
import LocationByPrefix from '../../../patients/dashboard/LocationByPrefix'
import { UserManagementIntent } from '../../../administration/constants'
import '../../../lms/lms.scss'
import { searchConstant } from '../../../../components/constants'
type Props = {
  patient: Patient | null
  loading: boolean
}

const RadiologyPatientInfo = ({ patient }: Props) => {
  const [provenances, setProvenances] = useState<
    Record<string, ProvenanceData>
  >({})
  const ids = patient ? patient?.id : undefined
  useEffect(() => {
    if (ids) {
      startSxpProxy(
        REGISTRATION_PROJECT_ID,
        UserManagementIntent?.fetchProvenance,
        {
          patientIds: ids,
        }
      )
        .then((data) => {
          const entries =
            data?.data?.entry?.map(
              (dde: { resource: Provenance | Practitioner }) => dde?.resource
            ) ?? []
          const obj = getProvenanceData(entries)
          setProvenances(obj)
        })
        .catch((err) => console.log(err))
    }
  }, [ids])

  if (!patient) return null
  const contactInformation =
    patient?.telecom?.find((t: any) => t?.system === searchConstant?.phone)
      ?.value || 'N/A'
  return (
    <div className='patient-info'>
      <div className='grid'>
        <div className='field'>
          <span className='label'>Patient Name</span>
          <span className='value'>{makeName(patient?.name) || 'N/A'}</span>
        </div>

        <div className='field'>
          <span className='label'>UHID</span>
          <span className='value'>
            {patient.identifier?.[2]?.value ??
              patient.identifier?.[0]?.value ??
              '-'}
          </span>
        </div>

        <div className='field'>
          <span className='label'>Gender</span>
          <span className='value'>{patient?.gender || 'N/A'}</span>
        </div>

        <div className='field'>
          <span className='label'>Age</span>
          <span className='value'>
            {patient?.birthDate
              ? `${
                  new Date().getFullYear() -
                  new Date(patient.birthDate).getFullYear()
                } years`
              : 'N/A'}
          </span>
        </div>

        <div className='field'>
          <span className='label'>Contact</span>
          <span className='value'>{contactInformation}</span>
        </div>

        <div className='field'>
          <span className='label'>Location</span>
          <span className='value'>
            <LocationByPrefix
              id={
                patient?.identifier?.[2]?.value ??
                patient?.identifier?.[0]?.value ??
                '-'
              }
            />
          </span>
        </div>

        <div className='field'>
          <span className='label'>Created</span>
          <span className='value'>
            <ProvenanceView
              date={provenances[ids ?? '']?.createdOn ?? ''}
              name={provenances[ids ?? '']?.createdBy ?? 'Unknown'}
              mode={'CREATE'}
            />
          </span>
        </div>

        <div className='field'>
          <span className='label'>Updated</span>
          <span className='value'>
            <ProvenanceView
              date={
                provenances[ids ?? '']?.updatedOn ??
                provenances[ids ?? '']?.createdOn ??
                ''
              }
              name={
                provenances[ids ?? '']?.updatedBy ??
                provenances[ids ?? '']?.createdBy ??
                'Unknown'
              }
              mode={'UPDATE'}
            />
          </span>
        </div>
      </div>
    </div>
  )
}

RadiologyPatientInfo.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.string.isRequired,
    birthDate: PropTypes.string,
    identifier: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
    name: PropTypes.array,
    gender: PropTypes.string,
    telecom: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
}

export default RadiologyPatientInfo
